<p>resident-customer works!</p>
